// extracted by mini-css-extract-plugin
module.exports = {"versionLink":"AnchorTag_versionLink__Ky6U3","versionIcon":"AnchorTag_versionIcon__7MrjO"};